export const pmsCompanies = [
  'Other',
  'None',
  '365 Villas',
  'Abode',
  'Anand Systems',
  'AvaiBook',
  'AvailRoom',
  'Avantio',
  'Avirato',
  'Barefoot',
  'Beddy',
  'Beds24',
  'BeeRent',
  'Bluetent (Boost)',
  'Boost',
  'Booker Tools',
  'Booking Experts',
  'BookingPal',
  'BookingSync',
  'Bookster',
  'Brightside Rental Management (Hawkins)',
  'ChannelConnector',
  'CiiRus',
  'Cloudbeds',
  'Creative Technologies (Citisoft)',
  'Direct',
  'Escapia',
  'Eviivo',
  'FeWo Verwalter',
  'FrontDeskAnywhere',
  'FutureStay',
  'Genkan',
  'GetDirect',
  'Guesty',
  'HOSTIFY',
  'HomHero',
  'HostAway',
  'Hostfully (Orbirental)',
  'iRent',
  'iTrip',
  'innRoad',
  'ITEA',
  'Icnea',
  'Kigo Marketplace',
  'Krossbooking',
  'Lightmaker',
  'LiveList',
  'LiveRez',
  'Lodgable',
  'Lodgify',
  'Lodgix',
  'Magarental',
  'MainApps / Magellano',
  'Maxxton',
  'Mercurio Sistemi s.r.l - Immobinet',
  'MyRent',
  'net2rent',
  'Newbook',
  'NextPax',
  'Octorate',
  'One Mineral',
  'OwnerRez',
  'Quick Connect',
  'RealTimeRental',
  'Redawning',
  'Rentals United',
  'Rentlio',
  'ResNexus',
  'ResOnline',
  'Reservit',
  'Resort Connect',
  'RezStream',
  'RoomCloud',
  'SabeeApp',
  'Sherlock',
  'SkyRun',
  'Smoobu',
  'Streamline',
  'Supercontrol',
  'Talkguest',
  'ThinkReservations',
  'Timeshare Software',
  'Tokeet',
  'Track Hospitality Software',
  'TravelSoft',
  'Travelstaytion ltd PMSC',
  'Uplisting',
  'VRBookings',
  'Vacation Rent Pro',
  'VacayHome Connect',
  'WebRezPro',
  'Wubook (Woodoo)',
];
